/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RecoverPasswordRouteImport } from './routes/recover-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index'
import { Route as LayoutSettingsRouteImport } from './routes/_layout/settings'
import { Route as LayoutDashboardRouteImport } from './routes/_layout/dashboard'
import { Route as LayoutAdminRouteImport } from './routes/_layout/admin'
import { Route as LayoutCalendarIndexRouteImport } from './routes/_layout/calendar/index'
import { Route as LayoutBookingsIndexRouteImport } from './routes/_layout/bookings.index'
import { Route as LayoutCalendarTaxiRouteImport } from './routes/_layout/calendar/taxi'
import { Route as LayoutCalendarKitchenRouteImport } from './routes/_layout/calendar/kitchen'
import { Route as LayoutCalendarKayakRouteImport } from './routes/_layout/calendar/kayak'
import { Route as LayoutBookingsNewRouteImport } from './routes/_layout/bookings.new'
import { Route as LayoutBookingsIdRouteImport } from './routes/_layout/bookings.$id'
import { Route as LayoutBookingsIdIndexRouteImport } from './routes/_layout/bookings.$id.index'
import { Route as LayoutBookingsIdEditRouteImport } from './routes/_layout/bookings.$id.edit'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RecoverPasswordRoute = RecoverPasswordRouteImport.update({
  id: '/recover-password',
  path: '/recover-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSettingsRoute = LayoutSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutDashboardRoute = LayoutDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAdminRoute = LayoutAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutCalendarIndexRoute = LayoutCalendarIndexRouteImport.update({
  id: '/calendar/',
  path: '/calendar/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutBookingsIndexRoute = LayoutBookingsIndexRouteImport.update({
  id: '/bookings/',
  path: '/bookings/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutCalendarTaxiRoute = LayoutCalendarTaxiRouteImport.update({
  id: '/calendar/taxi',
  path: '/calendar/taxi',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutCalendarKitchenRoute = LayoutCalendarKitchenRouteImport.update({
  id: '/calendar/kitchen',
  path: '/calendar/kitchen',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutCalendarKayakRoute = LayoutCalendarKayakRouteImport.update({
  id: '/calendar/kayak',
  path: '/calendar/kayak',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutBookingsNewRoute = LayoutBookingsNewRouteImport.update({
  id: '/bookings/new',
  path: '/bookings/new',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutBookingsIdRoute = LayoutBookingsIdRouteImport.update({
  id: '/bookings/$id',
  path: '/bookings/$id',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutBookingsIdIndexRoute = LayoutBookingsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutBookingsIdRoute,
} as any)
const LayoutBookingsIdEditRoute = LayoutBookingsIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => LayoutBookingsIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof LayoutIndexRoute
  '/login': typeof LoginRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/admin': typeof LayoutAdminRoute
  '/dashboard': typeof LayoutDashboardRoute
  '/settings': typeof LayoutSettingsRoute
  '/bookings/$id': typeof LayoutBookingsIdRouteWithChildren
  '/bookings/new': typeof LayoutBookingsNewRoute
  '/calendar/kayak': typeof LayoutCalendarKayakRoute
  '/calendar/kitchen': typeof LayoutCalendarKitchenRoute
  '/calendar/taxi': typeof LayoutCalendarTaxiRoute
  '/bookings/': typeof LayoutBookingsIndexRoute
  '/calendar/': typeof LayoutCalendarIndexRoute
  '/bookings/$id/edit': typeof LayoutBookingsIdEditRoute
  '/bookings/$id/': typeof LayoutBookingsIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/admin': typeof LayoutAdminRoute
  '/dashboard': typeof LayoutDashboardRoute
  '/settings': typeof LayoutSettingsRoute
  '/': typeof LayoutIndexRoute
  '/bookings/new': typeof LayoutBookingsNewRoute
  '/calendar/kayak': typeof LayoutCalendarKayakRoute
  '/calendar/kitchen': typeof LayoutCalendarKitchenRoute
  '/calendar/taxi': typeof LayoutCalendarTaxiRoute
  '/bookings': typeof LayoutBookingsIndexRoute
  '/calendar': typeof LayoutCalendarIndexRoute
  '/bookings/$id/edit': typeof LayoutBookingsIdEditRoute
  '/bookings/$id': typeof LayoutBookingsIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_layout': typeof LayoutRouteWithChildren
  '/login': typeof LoginRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_layout/admin': typeof LayoutAdminRoute
  '/_layout/dashboard': typeof LayoutDashboardRoute
  '/_layout/settings': typeof LayoutSettingsRoute
  '/_layout/': typeof LayoutIndexRoute
  '/_layout/bookings/$id': typeof LayoutBookingsIdRouteWithChildren
  '/_layout/bookings/new': typeof LayoutBookingsNewRoute
  '/_layout/calendar/kayak': typeof LayoutCalendarKayakRoute
  '/_layout/calendar/kitchen': typeof LayoutCalendarKitchenRoute
  '/_layout/calendar/taxi': typeof LayoutCalendarTaxiRoute
  '/_layout/bookings/': typeof LayoutBookingsIndexRoute
  '/_layout/calendar/': typeof LayoutCalendarIndexRoute
  '/_layout/bookings/$id/edit': typeof LayoutBookingsIdEditRoute
  '/_layout/bookings/$id/': typeof LayoutBookingsIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/recover-password'
    | '/reset-password'
    | '/admin'
    | '/dashboard'
    | '/settings'
    | '/bookings/$id'
    | '/bookings/new'
    | '/calendar/kayak'
    | '/calendar/kitchen'
    | '/calendar/taxi'
    | '/bookings/'
    | '/calendar/'
    | '/bookings/$id/edit'
    | '/bookings/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/recover-password'
    | '/reset-password'
    | '/admin'
    | '/dashboard'
    | '/settings'
    | '/'
    | '/bookings/new'
    | '/calendar/kayak'
    | '/calendar/kitchen'
    | '/calendar/taxi'
    | '/bookings'
    | '/calendar'
    | '/bookings/$id/edit'
    | '/bookings/$id'
  id:
    | '__root__'
    | '/_layout'
    | '/login'
    | '/recover-password'
    | '/reset-password'
    | '/_layout/admin'
    | '/_layout/dashboard'
    | '/_layout/settings'
    | '/_layout/'
    | '/_layout/bookings/$id'
    | '/_layout/bookings/new'
    | '/_layout/calendar/kayak'
    | '/_layout/calendar/kitchen'
    | '/_layout/calendar/taxi'
    | '/_layout/bookings/'
    | '/_layout/calendar/'
    | '/_layout/bookings/$id/edit'
    | '/_layout/bookings/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
  LoginRoute: typeof LoginRoute
  RecoverPasswordRoute: typeof RecoverPasswordRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recover-password': {
      id: '/recover-password'
      path: '/recover-password'
      fullPath: '/recover-password'
      preLoaderRoute: typeof RecoverPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/settings': {
      id: '/_layout/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof LayoutSettingsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard': {
      id: '/_layout/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof LayoutDashboardRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/admin': {
      id: '/_layout/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof LayoutAdminRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/calendar/': {
      id: '/_layout/calendar/'
      path: '/calendar'
      fullPath: '/calendar/'
      preLoaderRoute: typeof LayoutCalendarIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/bookings/': {
      id: '/_layout/bookings/'
      path: '/bookings'
      fullPath: '/bookings/'
      preLoaderRoute: typeof LayoutBookingsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/calendar/taxi': {
      id: '/_layout/calendar/taxi'
      path: '/calendar/taxi'
      fullPath: '/calendar/taxi'
      preLoaderRoute: typeof LayoutCalendarTaxiRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/calendar/kitchen': {
      id: '/_layout/calendar/kitchen'
      path: '/calendar/kitchen'
      fullPath: '/calendar/kitchen'
      preLoaderRoute: typeof LayoutCalendarKitchenRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/calendar/kayak': {
      id: '/_layout/calendar/kayak'
      path: '/calendar/kayak'
      fullPath: '/calendar/kayak'
      preLoaderRoute: typeof LayoutCalendarKayakRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/bookings/new': {
      id: '/_layout/bookings/new'
      path: '/bookings/new'
      fullPath: '/bookings/new'
      preLoaderRoute: typeof LayoutBookingsNewRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/bookings/$id': {
      id: '/_layout/bookings/$id'
      path: '/bookings/$id'
      fullPath: '/bookings/$id'
      preLoaderRoute: typeof LayoutBookingsIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/bookings/$id/': {
      id: '/_layout/bookings/$id/'
      path: '/'
      fullPath: '/bookings/$id/'
      preLoaderRoute: typeof LayoutBookingsIdIndexRouteImport
      parentRoute: typeof LayoutBookingsIdRoute
    }
    '/_layout/bookings/$id/edit': {
      id: '/_layout/bookings/$id/edit'
      path: '/edit'
      fullPath: '/bookings/$id/edit'
      preLoaderRoute: typeof LayoutBookingsIdEditRouteImport
      parentRoute: typeof LayoutBookingsIdRoute
    }
  }
}

interface LayoutBookingsIdRouteChildren {
  LayoutBookingsIdEditRoute: typeof LayoutBookingsIdEditRoute
  LayoutBookingsIdIndexRoute: typeof LayoutBookingsIdIndexRoute
}

const LayoutBookingsIdRouteChildren: LayoutBookingsIdRouteChildren = {
  LayoutBookingsIdEditRoute: LayoutBookingsIdEditRoute,
  LayoutBookingsIdIndexRoute: LayoutBookingsIdIndexRoute,
}

const LayoutBookingsIdRouteWithChildren =
  LayoutBookingsIdRoute._addFileChildren(LayoutBookingsIdRouteChildren)

interface LayoutRouteChildren {
  LayoutAdminRoute: typeof LayoutAdminRoute
  LayoutDashboardRoute: typeof LayoutDashboardRoute
  LayoutSettingsRoute: typeof LayoutSettingsRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutBookingsIdRoute: typeof LayoutBookingsIdRouteWithChildren
  LayoutBookingsNewRoute: typeof LayoutBookingsNewRoute
  LayoutCalendarKayakRoute: typeof LayoutCalendarKayakRoute
  LayoutCalendarKitchenRoute: typeof LayoutCalendarKitchenRoute
  LayoutCalendarTaxiRoute: typeof LayoutCalendarTaxiRoute
  LayoutBookingsIndexRoute: typeof LayoutBookingsIndexRoute
  LayoutCalendarIndexRoute: typeof LayoutCalendarIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutAdminRoute: LayoutAdminRoute,
  LayoutDashboardRoute: LayoutDashboardRoute,
  LayoutSettingsRoute: LayoutSettingsRoute,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutBookingsIdRoute: LayoutBookingsIdRouteWithChildren,
  LayoutBookingsNewRoute: LayoutBookingsNewRoute,
  LayoutCalendarKayakRoute: LayoutCalendarKayakRoute,
  LayoutCalendarKitchenRoute: LayoutCalendarKitchenRoute,
  LayoutCalendarTaxiRoute: LayoutCalendarTaxiRoute,
  LayoutBookingsIndexRoute: LayoutBookingsIndexRoute,
  LayoutCalendarIndexRoute: LayoutCalendarIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
  LoginRoute: LoginRoute,
  RecoverPasswordRoute: RecoverPasswordRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
